import { render, staticRenderFns } from "./ContentLendersList.vue?vue&type=template&id=f98da074&"
import script from "./ContentLendersList.vue?vue&type=script&lang=js&"
export * from "./ContentLendersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports